import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as classnames from "classnames";
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';

import "../../css/modal.css";
import {IReduxAppState} from "../../reducers";
import { closeModal} from "../../actions/modal"

const Modal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const visible = useSelector((state: IReduxAppState) => state.modal.visible);
    const header = useSelector((state: IReduxAppState) => state.modal.header);
    const body = useSelector((state: IReduxAppState) => state.modal.body);

    const overlayClasses = classnames("overlay", {
        "is-visible": visible
    });

    const modalClasses = classnames("modal", {
        "is-visible": visible
    });

    return <>
        <div
            className={overlayClasses}
            onClick={() => dispatch(closeModal())}
        ></div>

        <div className={modalClasses}>
            <div className="modal-header">{header}</div>

            <div className="modal-body">{body}</div>

            <div className="modal-footer">
                <Button
                    style={{"color": "#ffffff"}}
                    onClick={() => dispatch(closeModal())}>
                        {t("profile.modal.noVenue.close")}
                </Button>
            </div>
        </div>
    </>
}

export default Modal;